import findVendor from "./jedec_identification_codes";
import { buf2hex } from "./util";

class RDIDNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = "RDIDNotFoundError";
    }
}

class RDID {
    constructor(data) {
        if (!(data instanceof Uint8Array)) {
            throw new Error("Input must be a Uint8Array");
        }
        if(data.length != 3) {
            throw new Error("RDID must be 3 bytes long (received " + data.length + ")");
        }

        this.data = data;

        this.vendor_id = data[0];
        this.vendor = findVendor(data)
        this.type = data[1];
        this.capacity_code = data[2];

        // Most SPI flash vendors encode capacity in the 3rd RDID byte as
        // an exponent: density = 2^byte[2] bytes. Range-check so we don't
        // interpret garbage as a plausible capacity.
        if (this.capacity_code >= 0x10 && this.capacity_code <= 0x1F) {
            this.capacityBytes = Math.pow(2, this.capacity_code);
        } else {
            this.capacityBytes = null;
        }
    }
}

export { RDIDNotFoundError, RDID };
